export default __webpack_public_path__ + "static/media/Armbands of the Ubah Kan.6bddbb67.jpg";